import * as React from 'react';
import { ItemFieldProps } from './types';
import { DocSearch, GIcon, GoogleDoc } from '../../../Icon/icon';
import { Field, getValue } from './field';
import { Presentation } from 'rcd-cpp-ui/ui/icon';

const LinkIcon = {
  'Item.presentationLink': Presentation,
  'Item.googleDocumentUrl': GoogleDoc,
  'Item.cppItemDetailsURL': DocSearch,
  'Item.gcomURL': GIcon
};

export const LinkField = (props: ItemFieldProps) => {
  const { field, fieldInfo, item } = props;
  const schemaField = fieldInfo?.schemaField;
  const value = getValue(item, schemaField);
  if (!value) return null;

  const name = schemaField?.name;
  const Icon = LinkIcon[field];

  return (
    <Field fieldInfo={fieldInfo}>
      {name && <label>{name}:&nbsp;</label>}
      <a
        target="_blank"
        href={value}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {!!Icon ? <Icon /> : value}
      </a>
    </Field>
  );
};
